import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import ConversationsPaginatedGql from '@/extensions/chatbot/store/graphql/queries/ConversationsPaginated.gql';
import ConversationGql from '@/extensions/chatbot/store/graphql/queries/Conversation.gql';
import MessageGql from '@/extensions/chatbot/store/graphql/queries/Message.gql';

export default {
    fetchConversationsPaginated: data =>
        new Promise((resolve, reject) => {
            const filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: ConversationsPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'created_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        filters
                    },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.EX_CHATBOT_ConversationsPaginated))
                .catch(err => reject(err));
        }),

    fetchConversation: id =>
        new Promise((resolve, reject) => {
            if (id === undefined) throw new Error('required argument is missing');

            apolloClient
                .query({
                    query: ConversationGql,
                    variables: { id: parseInt(id) },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.EX_CHATBOT_Conversation))
                .catch(err => reject(err));
        }),

    // The source texts of an answer are fetched when a source is opened, not with the conversation.
    fetchMessage: id =>
        new Promise((resolve, reject) => {
            if (id === undefined) throw new Error('required argument is missing');

            apolloClient
                .query({
                    query: MessageGql,
                    variables: { id: parseInt(id) },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.EX_CHATBOT_Message))
                .catch(err => reject(err));
        })
};
